import AddChampionshipRequirements from "./AddChampionshipRequirements";

export default AddChampionshipRequirements;
